// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vkSFWBzAcR0JbTBnRk14,
.GTRoKlNymbJ1naH99N6l {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: var(--campaign-info-container-gap);
}
.GTRoKlNymbJ1naH99N6l {
  gap: var(--campaign-info-elements-gap);
  width: max-content;
  width: var(--campaign-info-elements-wrapper-width);
  flex-shrink: 0;
  min-width: 0;
}
.GTRoKlNymbJ1naH99N6l[data-collapsed='true'] {
  flex-direction: column;
  width: 100%;
  width: var(--campaign-info-elements-collapsed-width-desktop);
}
.GTRoKlNymbJ1naH99N6l[data-collapsed='true'][data-has-many='false'] {
  gap: var(--campaign-info-elements-gap-collapsed);
}
.Fc77mmUa0Qd0bgHgr4GU {
  display: flex;
  gap: var(--campaign-info-elements-gap);
  align-items: center;
  white-space: nowrap;
  flex-shrink: 0;
}
.Fc77mmUa0Qd0bgHgr4GU picture {
  display: flex;
}
.Fc77mmUa0Qd0bgHgr4GU img,
.Fc77mmUa0Qd0bgHgr4GU svg {
  width: var(--campaign-info-icon-size-desktop);
  height: var(--campaign-info-icon-size-desktop);
}
.Fc77mmUa0Qd0bgHgr4GU[data-collapsed='true'] img,
.Fc77mmUa0Qd0bgHgr4GU[data-collapsed='true'] svg {
  width: var(--campaign-info-icon-size-collapsed-desktop);
  height: var(--campaign-info-icon-size-collapsed-desktop);
  min-width: var(--campaign-info-icon-min-width-collapsed-desktop);
}
@media (min-width: 1025px) and (orientation: landscape) {
  [data-timer='true'][data-has-many='true'] .Fc77mmUa0Qd0bgHgr4GU[data-collapsed='false'] img,
  [data-timer='true'][data-has-many='true'] .Fc77mmUa0Qd0bgHgr4GU[data-collapsed='false'] svg {
    margin-top: var(--campaign-timer-icon-top-margin-desktop, 1px);
  }
}
.dpZOzMFupHntSIxzAWHf {
  display: flex;
  align-items: baseline;
}
.dpZOzMFupHntSIxzAWHf[data-claimed-win='true'][data-has-many='false'] {
  align-self: baseline;
}
.mx0vw0akJYrzsl3jlBgv,
.CCmALtzzH9j2o0CrjdNV {
  color: var(--campaign-color-text-white);
  text-align: center;
  font-family: var(--font-family-primary, inherit);
  font-weight: 400;
  line-height: normal;
}
.mx0vw0akJYrzsl3jlBgv {
  font-size: var(--campaign-info-label-font-desktop);
  font-style: normal;
}
.CCmALtzzH9j2o0CrjdNV {
  font-size: var(--campaign-info-dynamic-value-font-desktop);
  font-style: normal;
  font-family: var(--campaign-info-dynamic-value-font-family, var(--font-family-primary, inherit));
  font-weight: var(--campaign-info-dynamic-value-font-weight, 700);
  text-transform: capitalize;
  white-space: nowrap;
  line-height: 1;
  /* 2px positioning nudge + cap-alphabetic text-box trim (see campaign-variables.module.css).
       Same dead-space issue as the prize amount: the value is digits/colons only, so line-height: 1
       reserves descender space the font never uses. Margin trim replaces the old Chromium-only
       @supports (text-box-trim) block so the fix also lands in Firefox / older browsers.
       
       Only applies to --font-family-primary: a variant that overrides
       --campaign-info-dynamic-value-font-family must also reset the two margin vars below. */
  margin-top: var(--campaign-info-dynamic-value-margin-top, calc(2px + var(--campaign-futura-trim-top)));
  margin-bottom: var(--campaign-info-dynamic-value-margin-bottom, var(--campaign-futura-trim-bottom));
}
.CCmALtzzH9j2o0CrjdNV[data-active-slot='false'][data-finished='false'] {
  color: var(--campaign-info-dynamic-value-inactive-slot-color);
}
.CCmALtzzH9j2o0CrjdNV[data-active-slot='true']:not([data-finished='true']) {
  color: var(--campaign-info-dynamic-value-active-slot-color);
}
.CCmALtzzH9j2o0CrjdNV[data-finished='true'] {
  color: var(--campaign-info-finished-text-color);
}
.CCmALtzzH9j2o0CrjdNV[data-timer='true'] {
  text-transform: uppercase;
  letter-spacing: 0.65px;
}
.CCmALtzzH9j2o0CrjdNV[data-timer='true'][data-less-than-hour='true'] {
  color: var(--campaign-color-timer-ends);
}
.CCmALtzzH9j2o0CrjdNV[data-timer='true'][data-less-than-hour='false'] {
  color: var(--campaign-color-timer-starts);
}
.CCmALtzzH9j2o0CrjdNV[data-claimed-win='true'] {
  color: var(--campaign-color-timer-starts);
}
.CCmALtzzH9j2o0CrjdNV[data-claimed-win='true'][data-has-many='false'] {
  font-size: 24px;
}
@media (min-width: 1025px) and (orientation: landscape) {
  .CCmALtzzH9j2o0CrjdNV[data-has-many='true'] {
    font-size: var(--campaign-info-dynamic-value-font-has-many-desktop);
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .GTRoKlNymbJ1naH99N6l {
    gap: var(--campaign-info-elements-gap-mobile);
    flex-shrink: unset;
    width: var(--campaign-info-elements-wrapper-width-mobile);
  }
  .GTRoKlNymbJ1naH99N6l[data-collapsed='true'] {
    max-width: var(--campaign-info-elements-collapsed-width-mobile);
  }
  .GTRoKlNymbJ1naH99N6l[data-collapsed='true'][data-has-many='false'] {
    width: var(--campaign-info-elements-collapsed-width-mobile-has-many-false);
  }
  .GTRoKlNymbJ1naH99N6l.gWHnYBhxM2ctdUy1IeWS {
    flex-direction: row;
  }
  .mx0vw0akJYrzsl3jlBgv {
    font-size: var(--campaign-info-label-font-mobile);
  }
  .Fc77mmUa0Qd0bgHgr4GU {
    gap: 4px;
  }
  .Fc77mmUa0Qd0bgHgr4GU img,
  .Fc77mmUa0Qd0bgHgr4GU svg,
  .Fc77mmUa0Qd0bgHgr4GU[data-collapsed='true'] img,
  .Fc77mmUa0Qd0bgHgr4GU[data-collapsed='true'] svg {
    width: var(--campaign-info-icon-size-mobile);
    height: var(--campaign-info-icon-size-mobile);
    min-width: var(--campaign-info-icon-min-width-mobile);
  }
  .Fc77mmUa0Qd0bgHgr4GU[data-collapsed='false'] img,
  .Fc77mmUa0Qd0bgHgr4GU[data-collapsed='false'] svg {
    width: var(--campaign-info-icon-size-mobile);
    height: var(--campaign-info-icon-size-mobile);
  }
  .CCmALtzzH9j2o0CrjdNV {
    font-size: var(--campaign-info-dynamic-value-font-mobile);
  }
  .CCmALtzzH9j2o0CrjdNV[data-claimed-win='true'][data-has-many='false'] {
    font-size: 16px;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) {
  .GTRoKlNymbJ1naH99N6l[data-collapsed='true'][data-has-many='false'] {
    gap: var(--campaign-info-elements-gap-mobile);
  }
  .dpZOzMFupHntSIxzAWHf[data-claimed-win='true'][data-has-many='false'] {
    align-self: unset;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) {
  .GTRoKlNymbJ1naH99N6l[data-collapsed='true'][data-has-many='false'] {
    gap: var(--campaign-info-elements-gap-mobile);
  }
  .dpZOzMFupHntSIxzAWHf[data-claimed-win='true'][data-has-many='false'] {
    align-self: unset;
  }
}
}
}
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) and (max-width: 767px) {
  .vkSFWBzAcR0JbTBnRk14 {
    gap: 0;
  }
  .GTRoKlNymbJ1naH99N6l {
    width: 100%;
    flex-direction: column;
    gap: var(--campaign-info-elements-gap-mobile);
  }
  .Fc77mmUa0Qd0bgHgr4GU {
    flex-direction: row;
    gap: 4px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) and (max-width: 767px) {
  .vkSFWBzAcR0JbTBnRk14 {
    gap: 0;
  }
  .GTRoKlNymbJ1naH99N6l {
    width: 100%;
    flex-direction: column;
    gap: var(--campaign-info-elements-gap-mobile);
  }
  .Fc77mmUa0Qd0bgHgr4GU {
    flex-direction: row;
    gap: 4px;
  }
}
}
}
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: landscape) {
  .GTRoKlNymbJ1naH99N6l[data-collapsed='true'][data-has-many='false'] {
    gap: var(--campaign-info-elements-gap-collapsed-landscape);
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: landscape) {
  .GTRoKlNymbJ1naH99N6l[data-collapsed='true'][data-has-many='false'] {
    gap: var(--campaign-info-elements-gap-collapsed-landscape);
  }
}
}
}
}
.NFjPj0uXVvlFsFID42_6 {
  position: relative;
  color: var(--campaign-info-finished-text-color);
}
.kzbNrDy2mWcHogQdiqXE {
  visibility: hidden;
}
.n0EoThoIhDALfRPXRjS4 {
  display: inline-block;
  height: 70%;
}
.ayZv7fkafAVpDUY8WBQ9 {
  border-left: 2px solid var(--campaign-color-text-white);
}
.pbM0FIdYDj9dSXMToKXH {
  border-left: 1px solid var(--campaign-color-text-white);
}
.SfVqFQ4Oq05l6_60yMvM {
  border-left: 3px solid var(--campaign-color-text-white);
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/BottomCardInfo/css/base/CampaignInfoDisplay.base.module.css"],"names":[],"mappings":"AAAA;;EAEE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;AACzC;AACA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,kDAAkD;EAClD,cAAc;EACd,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,4DAA4D;AAC9D;AACA;EACE,gDAAgD;AAClD;AACA;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;;EAEE,6CAA6C;EAC7C,8CAA8C;AAChD;AACA;;EAEE,uDAAuD;EACvD,wDAAwD;EACxD,gEAAgE;AAClE;AACA;EACE;;IAEE,8DAA8D;EAChE;AACF;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;;EAEE,uCAAuC;EACvC,kBAAkB;EAClB,gDAAgD;EAChD,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kDAAkD;EAClD,kBAAkB;AACpB;AACA;EACE,0DAA0D;EAC1D,kBAAkB;EAClB,gGAAgG;EAChG,gEAAgE;EAChE,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd;;;;;;6FAM2F;EAC3F,sGAAsG;EACtG,mGAAmG;AACrG;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,+CAA+C;AACjD;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,mEAAmE;EACrE;AACF;AACA;EACE;IACE,6CAA6C;IAC7C,kBAAkB;IAClB,yDAAyD;EAC3D;EACA;IACE,+DAA+D;EACjE;EACA;IACE,0EAA0E;EAC5E;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iDAAiD;EACnD;EACA;IACE,QAAQ;EACV;EACA;;;;IAIE,4CAA4C;IAC5C,6CAA6C;IAC7C,qDAAqD;EACvD;EACA;;IAEE,4CAA4C;IAC5C,6CAA6C;EAC/C;EACA;IACE,yDAAyD;EAC3D;EACA;IACE,eAAe;EACjB;AACF;AACA;AAAA;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,iBAAiB;EACnB;AACF;AAAA;AAPA;AAAA;AAAA;AAAA;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,iBAAiB;EACnB;AACF;AAAA;AAAA;AAAA;AACA;AAAA;EACE;IACE,MAAM;EACR;EACA;IACE,WAAW;IACX,sBAAsB;IACtB,6CAA6C;EAC/C;EACA;IACE,mBAAmB;IACnB,QAAQ;EACV;AACF;AAAA;AAbA;AAAA;AAAA;AAAA;EACE;IACE,MAAM;EACR;EACA;IACE,WAAW;IACX,sBAAsB;IACtB,6CAA6C;EAC/C;EACA;IACE,mBAAmB;IACnB,QAAQ;EACV;AACF;AAAA;AAAA;AAAA;AACA;AAAA;EACE;IACE,0DAA0D;EAC5D;AACF;AAAA;AAJA;AAAA;AAAA;AAAA;EACE;IACE,0DAA0D;EAC5D;AACF;AAAA;AAAA;AAAA;AACA;EACE,kBAAkB;EAClB,+CAA+C;AACjD;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,uDAAuD;AACzD;AACA;EACE,uDAAuD;AACzD;AACA;EACE,uDAAuD;AACzD","sourcesContent":[".campaignInfoDisplayContainer,\n.campaignInfoDisplayElementsWrapper {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: var(--campaign-info-container-gap);\n}\n.campaignInfoDisplayElementsWrapper {\n  gap: var(--campaign-info-elements-gap);\n  width: max-content;\n  width: var(--campaign-info-elements-wrapper-width);\n  flex-shrink: 0;\n  min-width: 0;\n}\n.campaignInfoDisplayElementsWrapper[data-collapsed='true'] {\n  flex-direction: column;\n  width: 100%;\n  width: var(--campaign-info-elements-collapsed-width-desktop);\n}\n.campaignInfoDisplayElementsWrapper[data-collapsed='true'][data-has-many='false'] {\n  gap: var(--campaign-info-elements-gap-collapsed);\n}\n.imageLabelWrapper {\n  display: flex;\n  gap: var(--campaign-info-elements-gap);\n  align-items: center;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.imageLabelWrapper picture {\n  display: flex;\n}\n.imageLabelWrapper img,\n.imageLabelWrapper svg {\n  width: var(--campaign-info-icon-size-desktop);\n  height: var(--campaign-info-icon-size-desktop);\n}\n.imageLabelWrapper[data-collapsed='true'] img,\n.imageLabelWrapper[data-collapsed='true'] svg {\n  width: var(--campaign-info-icon-size-collapsed-desktop);\n  height: var(--campaign-info-icon-size-collapsed-desktop);\n  min-width: var(--campaign-info-icon-min-width-collapsed-desktop);\n}\n@media (--campaign-desktop) {\n  [data-timer='true'][data-has-many='true'] .imageLabelWrapper[data-collapsed='false'] img,\n  [data-timer='true'][data-has-many='true'] .imageLabelWrapper[data-collapsed='false'] svg {\n    margin-top: var(--campaign-timer-icon-top-margin-desktop, 1px);\n  }\n}\n.dynamicValueWrapper {\n  display: flex;\n  align-items: baseline;\n}\n.dynamicValueWrapper[data-claimed-win='true'][data-has-many='false'] {\n  align-self: baseline;\n}\n.labelText,\n.dynamicValue {\n  color: var(--campaign-color-text-white);\n  text-align: center;\n  font-family: var(--font-family-primary, inherit);\n  font-weight: 400;\n  line-height: normal;\n}\n.labelText {\n  font-size: var(--campaign-info-label-font-desktop);\n  font-style: normal;\n}\n.dynamicValue {\n  font-size: var(--campaign-info-dynamic-value-font-desktop);\n  font-style: normal;\n  font-family: var(--campaign-info-dynamic-value-font-family, var(--font-family-primary, inherit));\n  font-weight: var(--campaign-info-dynamic-value-font-weight, 700);\n  text-transform: capitalize;\n  white-space: nowrap;\n  line-height: 1;\n  /* 2px positioning nudge + cap-alphabetic text-box trim (see campaign-variables.module.css).\n       Same dead-space issue as the prize amount: the value is digits/colons only, so line-height: 1\n       reserves descender space the font never uses. Margin trim replaces the old Chromium-only\n       @supports (text-box-trim) block so the fix also lands in Firefox / older browsers.\n       \n       Only applies to --font-family-primary: a variant that overrides\n       --campaign-info-dynamic-value-font-family must also reset the two margin vars below. */\n  margin-top: var(--campaign-info-dynamic-value-margin-top, calc(2px + var(--campaign-futura-trim-top)));\n  margin-bottom: var(--campaign-info-dynamic-value-margin-bottom, var(--campaign-futura-trim-bottom));\n}\n.dynamicValue[data-active-slot='false'][data-finished='false'] {\n  color: var(--campaign-info-dynamic-value-inactive-slot-color);\n}\n.dynamicValue[data-active-slot='true']:not([data-finished='true']) {\n  color: var(--campaign-info-dynamic-value-active-slot-color);\n}\n.dynamicValue[data-finished='true'] {\n  color: var(--campaign-info-finished-text-color);\n}\n.dynamicValue[data-timer='true'] {\n  text-transform: uppercase;\n  letter-spacing: 0.65px;\n}\n.dynamicValue[data-timer='true'][data-less-than-hour='true'] {\n  color: var(--campaign-color-timer-ends);\n}\n.dynamicValue[data-timer='true'][data-less-than-hour='false'] {\n  color: var(--campaign-color-timer-starts);\n}\n.dynamicValue[data-claimed-win='true'] {\n  color: var(--campaign-color-timer-starts);\n}\n.dynamicValue[data-claimed-win='true'][data-has-many='false'] {\n  font-size: 24px;\n}\n@media (min-width: 1025px) and (orientation: landscape) {\n  .dynamicValue[data-has-many='true'] {\n    font-size: var(--campaign-info-dynamic-value-font-has-many-desktop);\n  }\n}\n@media (--campaign-mobile) {\n  .campaignInfoDisplayElementsWrapper {\n    gap: var(--campaign-info-elements-gap-mobile);\n    flex-shrink: unset;\n    width: var(--campaign-info-elements-wrapper-width-mobile);\n  }\n  .campaignInfoDisplayElementsWrapper[data-collapsed='true'] {\n    max-width: var(--campaign-info-elements-collapsed-width-mobile);\n  }\n  .campaignInfoDisplayElementsWrapper[data-collapsed='true'][data-has-many='false'] {\n    width: var(--campaign-info-elements-collapsed-width-mobile-has-many-false);\n  }\n  .campaignInfoDisplayElementsWrapper.totalLeftPrizesCollapsed {\n    flex-direction: row;\n  }\n  .labelText {\n    font-size: var(--campaign-info-label-font-mobile);\n  }\n  .imageLabelWrapper {\n    gap: 4px;\n  }\n  .imageLabelWrapper img,\n  .imageLabelWrapper svg,\n  .imageLabelWrapper[data-collapsed='true'] img,\n  .imageLabelWrapper[data-collapsed='true'] svg {\n    width: var(--campaign-info-icon-size-mobile);\n    height: var(--campaign-info-icon-size-mobile);\n    min-width: var(--campaign-info-icon-min-width-mobile);\n  }\n  .imageLabelWrapper[data-collapsed='false'] img,\n  .imageLabelWrapper[data-collapsed='false'] svg {\n    width: var(--campaign-info-icon-size-mobile);\n    height: var(--campaign-info-icon-size-mobile);\n  }\n  .dynamicValue {\n    font-size: var(--campaign-info-dynamic-value-font-mobile);\n  }\n  .dynamicValue[data-claimed-win='true'][data-has-many='false'] {\n    font-size: 16px;\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) {\n  .campaignInfoDisplayElementsWrapper[data-collapsed='true'][data-has-many='false'] {\n    gap: var(--campaign-info-elements-gap-mobile);\n  }\n  .dynamicValueWrapper[data-claimed-win='true'][data-has-many='false'] {\n    align-self: unset;\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) and (--campaign-tablet-portrait-rule) {\n  .campaignInfoDisplayContainer {\n    gap: 0;\n  }\n  .campaignInfoDisplayElementsWrapper {\n    width: 100%;\n    flex-direction: column;\n    gap: var(--campaign-info-elements-gap-mobile);\n  }\n  .imageLabelWrapper {\n    flex-direction: row;\n    gap: 4px;\n  }\n}\n@media (--campaign-mobile) and (orientation: landscape) {\n  .campaignInfoDisplayElementsWrapper[data-collapsed='true'][data-has-many='false'] {\n    gap: var(--campaign-info-elements-gap-collapsed-landscape);\n  }\n}\n.finishedContainer {\n  position: relative;\n  color: var(--campaign-info-finished-text-color);\n}\n.hiddenPlaceholder {\n  visibility: hidden;\n}\n.separator {\n  display: inline-block;\n  height: 70%;\n}\n.default {\n  border-left: 2px solid var(--campaign-color-text-white);\n}\n.thin {\n  border-left: 1px solid var(--campaign-color-text-white);\n}\n.thick {\n  border-left: 3px solid var(--campaign-color-text-white);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"campaignInfoDisplayContainer": `vkSFWBzAcR0JbTBnRk14`,
	"campaignInfoDisplayElementsWrapper": `GTRoKlNymbJ1naH99N6l`,
	"imageLabelWrapper": `Fc77mmUa0Qd0bgHgr4GU`,
	"dynamicValueWrapper": `dpZOzMFupHntSIxzAWHf`,
	"labelText": `mx0vw0akJYrzsl3jlBgv`,
	"dynamicValue": `CCmALtzzH9j2o0CrjdNV`,
	"totalLeftPrizesCollapsed": `gWHnYBhxM2ctdUy1IeWS`,
	"finishedContainer": `NFjPj0uXVvlFsFID42_6`,
	"hiddenPlaceholder": `kzbNrDy2mWcHogQdiqXE`,
	"separator": `n0EoThoIhDALfRPXRjS4`,
	"default": `ayZv7fkafAVpDUY8WBQ9`,
	"thin": `pbM0FIdYDj9dSXMToKXH`,
	"thick": `SfVqFQ4Oq05l6_60yMvM`
};
export default ___CSS_LOADER_EXPORT___;
